<script setup lang="ts">
import { ref, watch, nextTick } from 'vue';

const openItems = ref<Set<string>>(new Set());
const rootRef = ref<HTMLElement | null>(null);

const toggleItem = (itemId: string) => {
  if (openItems.value.has(itemId)) {
    openItems.value.delete(itemId);
  } else {
    openItems.value.clear();
    openItems.value.add(itemId);
  }
};

const closeItem = (itemId: string) => {
  openItems.value.delete(itemId);
};

const closeAllItems = () => {
  openItems.value.clear();
};

const isItemOpen = (itemId: string): boolean => {
  return openItems.value.has(itemId);
};

const handleClick = (event: MouseEvent) => {
  const target = event.target as HTMLElement;
  const toggleButton = target.closest('[data-mobile-menu-toggle]');

  if (!toggleButton) return;

  const menuItem = toggleButton.closest('.mobilemenu__item');
  if (!menuItem) return;

  const itemId = menuItem.getAttribute('data-menu-item-id');
  if (!itemId) return;

  event.preventDefault();
  toggleItem(itemId);
};

const updateItemClasses = () => {
  if (!rootRef.value) return;

  nextTick(() => {
    const items = rootRef.value?.querySelectorAll('.mobilemenu__item[data-menu-item-id]');
    items?.forEach(item => {
      const itemId = item.getAttribute('data-menu-item-id');
      if (!itemId) return;

      if (isItemOpen(itemId)) {
        item.classList.remove('closed');
        item.classList.add('open');
      } else {
        item.classList.remove('open');
        item.classList.add('closed');
      }
    });
  });
};

watch(
  openItems,
  () => {
    updateItemClasses();
  },
  { deep: true }
);

watch(rootRef, () => {
  if (rootRef.value) {
    updateItemClasses();
  }
});

defineExpose({
  toggleItem,
  closeItem,
  closeAllItems,
  isItemOpen,
});
</script>

<template>
  <div ref="rootRef" class="mobilemenu" @click="handleClick">
    <slot />
  </div>
</template>

<style lang="scss"></style>
